// PWAInstallContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';

export const PWAInstallContext = createContext(null);

export const PWAInstallProvider = ({ children }) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };
        window.addEventListener('beforeinstallprompt', handler);
        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    return (
        <PWAInstallContext.Provider value={{ deferredPrompt, setDeferredPrompt }}>
            {children}
        </PWAInstallContext.Provider>
    );
};

// Hook بسيط للوصول للكونتكست
export const usePWAInstall = () => useContext(PWAInstallContext);
